<template>
  <div>
    <!-- <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">

      <CommunityInfo
        :communityInfo="communityInfo"
        @onRelatedCommunityChanged="showRelatedCommunity"
      />
    </v-skeleton-loader>
    <InternalBreadcrumbs :breadcrumbs="breadcrumbs" ref="actionSection" /> -->

    <v-card elevation="0">
      <v-card-title class="orange-bg font-weight-bold white--text">
        Walk-Trhoughs
        <v-divider
          vertical
          thickness="2"
          class="border-opacity-100 mx-3"
          color="white"
        >
        </v-divider>
        <router-link :to="`/customers/${customerId}`">
          Back to Dashboard
        </router-link></v-card-title
      >
      <v-card-text>
        <!-- Start Recent Orange Reports section -->
        <v-progress-linear
          :active="walkThroughsLoading"
          :indeterminate="walkThroughsLoading"
          absolute
          bottom
        ></v-progress-linear>
        <div v-if="!walkThroughsLoading">
          <v-row v-if="sortedWalkThroughs.length > 0">
            <v-col
              md="2"
              sm="3"
              cols="4"
              v-for="(item, i) in sortedWalkThroughs"
              :key="'o' + i"
            >
              <div>
                <p>
                  {{ item.title }}
                  <router-link
                    v-if="item.isApproved"
                    class="orange--text"
                    :to="
                      `/customers/${customerId}/walkthroughs/${item.id}/view`
                    "
                    >View Walk-Through</router-link
                  >
                  <router-link
                    v-else
                    class="green--text"
                    :to="
                      `/customers/${customerId}/walkthroughs/${item.id}/edit`
                    "
                    >{{
                      permissions.orangeReport &&
                      permissions.orangeReport.canApprove
                        ? "Edit / Approve "
                        : "Edit "
                    }}
                    Walk-Trhough</router-link
                  >
                </p>
                <router-link
                  class="orange--text"
                  :to="
                    `/customers/${customerId}/walkthroughs/${item.id}/${
                      item.isApproved ? 'view' : 'edit'
                    }`
                  "
                >
                  <v-img
                    height="200"
                    width="300"
                    :src="walkThroughPicture(item)"
                  ></v-img>
                </router-link>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <div class="text-subtitle-1 text-center">
                No Walk-throughs
              </div>
              <router-link
                v-if="
                  permissions.orangeReport && permissions.orangeReport.canCreate
                "
                :to="`/customers/${customerId}/walkthroughs/new`"
              >
                <v-btn class="orange-bg white--text" small>
                  Create Walk-Through
                </v-btn>
              </router-link>
            </v-col>
          </v-row>
        </div>

        <!-- End Recent Orange Reports section -->
      </v-card-text>
    </v-card>
    <!-- </v-container> -->
  </div>
</template>

<script>
// import CommunityInfo from "@/view/components/CommunityInfo.vue";
// import InternalBreadcrumbs from "@/view/components/DashboardInternalBreadcrumbs.vue";
import { GET_QUERY, API_CUSTOMERS } from "@/core/store/crud.module";
import crud from "@/core/helpers/crud";
// import { API_USERS } from "@/core/store/crud.module";
import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
// import moment from "moment";
import permissionsHelper from "@/core/helpers/permissionsHelper";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo,
    // InternalBreadcrumbs
  },
  data: () => ({
    communityInfo: {},
    options: {
      page: 1,
      itemsPerPage: 5
    },
    walkThroughs: [],
    sortedWalkThroughs: [],
    walkThroughsLoading: false,

    relatedCommunity: null,
    relatedCommunityItems: [],
    pageText: "",
    hasMore: false,
    isLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    permissions: {}
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {},
  async mounted() {
    // this.loading = true;
    // await this.getComunityInfo();
    // await this.createBreadcrumb();
    // await this.setInternalBreadcrumbs();
    // this.loading = false;
    await this.getRecentWalkThroughs();
    this.$nextTick(() => {
      this.$refs.actionSection.$el.scrollIntoView({
        block: "end",
        scrollBehavior: "smooth"
      }); //.scrollTop = 0;
    });
  },
  async created() {
    permissionsHelper.getPermissions().then(this.getPermissions);
    await this.getComunityInfo();
  },
  methods: {
    showRelatedCommunity(communityId) {
      this.$router.push({
        name: "CustomerDetails",
        params: { customerId: communityId }
      });
    },
    async getComunityInfo() {
      this.loading = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_CUSTOMERS,
          id: this.customerId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.communityInfo = crud.getPopulatedComunityInfo(response.data);
            this.createBreadcrumb();
            this.setInternalBreadcrumbs();
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.loading = false;
        });
    },
    async getRecentWalkThroughs() {
      this.walkThroughsLoading = true;

      let reportsUrl = `${API_CUSTOMERS}/${this.customerId}/walkThroughs`;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: reportsUrl
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.walkThroughs = response.data.$values;
            this.sortedWalkThroughs = this.walkThroughs.slice().sort((a, b) => {
              return new Date(b.walkThroughDate) - new Date(a.walkThroughDate);
            });
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.walkThroughsLoading = false;
        });
    },
    walkThroughPicture(report) {
      let defaultPicture =
        "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      if (!report) return defaultPicture;

      // if (report.photos.$values.length > 0) {
      //   let imagesToShow = report.photos.$values.filter(i => i.showInReport);
      //   if (imagesToShow && imagesToShow.length > 0)
      //     return imagesToShow[0].fileUrl;
      //   return report.photos.$values[0].fileUrl;
      // }

      return defaultPicture;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
    },

    getPermissions(permissionsObj) {
      this.permissions = permissionsObj;
    },

    formatDate(date) {
      return dateFormatter.formatEditDate(date);
    },
    formatDateUs(date) {
      // return moment(date).format("MM/DD/YYYY");
      return dateFormatter.formatDateUs(date);
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
  },
  computed: {}
};
</script>
